export default "__VITE_ASSET__BDtN4$7B__"